<ngx-spinner bdColor="rgba(0,0,0,0)"
             size="medium"
             color="#000000"
             type="ball-spin-clockwise">
</ngx-spinner>
<div class="modal-signup modal-content">
  <div>
    <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form document">


      <div class="card-header wh-header padding-bottom-0px">

        Edit Medicine

        <button type="button" class="close" data-dismiss="modal"
                (click)="activeModal.dismiss('Cross click')"
                aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="card-body padding-bottom-0px padding-right-0px margin-left-0px padding-top-10px">
        <form class="form" novalidate="" (ngSubmit)="onSubmit()" #f="ngForm">
          <div class="modal-body padding-top-0px">








            <div class="row margin-left-auto">
              <div class="col-md-12 padding-l-0px">




                <div class="row">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <!--<div class="col-md-3 text-align-right">
                        <label for="firstName" class="margin-bottom-0px margin-top-5px">Medicine</label>
                      </div>-->
                      <div class="offset-md-1 col-md-6 padding-left-9px">

                        <!--<CodeTypeValue CodeType="MARTL"
                        id="CurrentSaveIvfCycleMedicineDataRequest.MedicineName"
                        [(ngModel)]="CurrentSaveIvfCycleMedicineDataRequest.MedicineName" SelectedValue=""
                        name="CurrentSaveIvfCycleMedicineDataRequest.MedicineName" required></CodeTypeValue>-->
                        <!--<input type="text" class="form-control" placeholder="Test"
                               id="CurrentSaveIvfCycleMedicineDataRequest.MedicineName"
                               [(ngModel)]="CurrentSaveIvfCycleMedicineDataRequest.MedicineName"
                               name="CurrentSaveIvfCycleMedicineDataRequest.MedicineName" #Doctor="ngModel"
                               maxlength="100" required>
                        <small class="form-text text-danger"
                               *ngIf="(!Doctor.valid && (Doctor.dirty || Doctor.touched) && Doctor.errors.required )">(Field cannot be left blank)</small>
                        <small class="form-text text-danger"
                               *ngIf="(!Doctor.valid && Doctor.errors.pattern)">(special characters are not allowed)</small>-->
                        <h4 class="margin-bottom-0px color-Assign font-size-16px font-weight-bold">{{MedicineName}}</h4>

                      </div>




                    </div>

                  </div>
                </div>


                <div class="row">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-3 text-align-right margin-top-5px">
                        <label for="diaplayName" class="margin-bottom-0px">Purpose</label>
                      </div>
                      <div class="col-md-6">

                        <CodeTypeValue CodeType="MDPUR" id="CurrentEditClinicalOrderRxHeaderInfoRequest.Purpose"
                                       [(ngModel)]="CurrentEditClinicalOrderRxHeaderInfoRequest.Purpose" SelectedValue="CurrentEditClinicalOrderRxHeaderInfoRequest.Purpose"
                                       name="CurrentEditClinicalOrderRxHeaderInfoRequest.Purpose">

                        </CodeTypeValue>

                      </div>



                    </div>


                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                    <div class="row">
                      <div class="col-md-3 text-align-right">
                        <label for="firstName" class="margin-bottom-0px margin-top-5px">Dose</label>
                      </div>
                      <div class="col-md-2 padding-right-0px col-5">

                        <input type="text" class="form-control" placeholder="Dose"
                               id="CurrentEditClinicalOrderRxHeaderInfoRequest.Dose"
                               [(ngModel)]="CurrentEditClinicalOrderRxHeaderInfoRequest.Dose"
                               name="CurrentEditClinicalOrderRxHeaderInfoRequest.Dose" pattern="^[\0-9,._\-?]*$" #RecommendedPackage="ngModel"
                               maxlength="5">
                        <small class="form-text text-danger"
                               *ngIf="(!RecommendedPackage.valid && RecommendedPackage.errors.pattern)">(only numbers are allowed)</small>


                      </div>
                      <div class="col-md-2 padding-right-0px col-3">
                        <CodeTypeValue CodeType="MEDDS"
                                       id="CurrentEditClinicalOrderRxHeaderInfoRequest.DurationType" placeholder="Units"
                                       [(ngModel)]="CurrentEditClinicalOrderRxHeaderInfoRequest.DurationType" SelectedValue="CurrentEditClinicalOrderRxHeaderInfoRequest.DurationType"
                                       name="CurrentEditClinicalOrderRxHeaderInfoRequest.DurationType" required></CodeTypeValue>



                      </div>

                    </div>

                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-3 text-align-right margin-top-5px">
                        <label for="diaplayName" class="margin-bottom-0px">Route</label>
                      </div>
                      <div class="col-md-4">

                        <CodeTypeValue CodeType="IVFDF" id="CurrentEditClinicalOrderRxHeaderInfoRequest.Route"
                                       [(ngModel)]="CurrentEditClinicalOrderRxHeaderInfoRequest.Route" SelectedValue="CurrentEditClinicalOrderRxHeaderInfoRequest.Route"
                                       name="CurrentEditClinicalOrderRxHeaderInfoRequest.Route">

                        </CodeTypeValue>

                      </div>



                    </div>


                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-3 text-align-right margin-top-5px">
                        <label for="diaplayName" class="margin-bottom-0px">Frequency</label>
                      </div>
                      <div class="col-md-4">

                        <CodeTypeValue CodeType="RXFRE" id="CurrentEditClinicalOrderRxHeaderInfoRequest.Frequency"
                                       [(ngModel)]="CurrentEditClinicalOrderRxHeaderInfoRequest.Frequency" SelectedValue=""
                                       name="CurrentEditClinicalOrderRxHeaderInfoRequest.Frequency">

                        </CodeTypeValue>

                      </div>



                    </div>


                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                    <div class="row">
                      <div class="col-md-3 text-align-right margin-top-7px ">
                        <label for="diaplayName" class="font-size-12px margin-bottom-0px">From Date</label>
                      </div>


                      <div class="col-md-4 col-5">
                        <div class="date-form">
                          <input class="form-control" placeholder="Date " [minDate]="minDate" [maxDate]="maxDate"
                                 name="dp1" [(ngModel)]="StartDate" ngbDatepicker #dsF="ngbDatepicker" #DateF="ngModel" required>
                          <small class="form-text text-danger"
                                 *ngIf="(!DateF.valid && (DateF.dirty || DateF.touched) && DateF.errors.required)">(Field cannot be left blank)</small>

                          <a (click)="dsF.toggle()" class="nav-link-hand">
                            <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                          </a>

                        </div>
                      </div>
                    </div>


                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                    <div class="row">
                      <div class="col-md-3 text-align-right margin-top-7px ">
                        <label for="diaplayName" class="font-size-12px margin-bottom-0px">To Date</label>
                      </div>


                      <div class="col-md-4 col-5">
                        <div class="date-form">
                          <input class="form-control" placeholder="Date " [minDate]="minDate" [maxDate]="maxDate"
                                 name="dp2" [(ngModel)]="ToDate" ngbDatepicker #dsT="ngbDatepicker" #DateT="ngModel" required>
                          <small class="form-text text-danger"
                                 *ngIf="(!DateT.valid && (DateT.dirty || DateT.touched) && DateT.errors.required)">(Field cannot be left blank)</small>

                          <a (click)="dsT.toggle()" class="nav-link-hand">
                            <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                          </a>

                        </div>
                      </div>
                    </div>


                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-3 text-align-right ">
                        <label for="diaplayName">Instructions </label>
                      </div>
                      <div class="col-md-8 padding-right-0px ">
                        <!--<CodeTypeValue CodeType="MARTL"></CodeTypeValue>-->

                        <textarea class="form-control3 size-2 width-inherit" rows="2" placeholder="Type Instructions"
                                  name="CurrentEditClinicalOrderRxHeaderInfoRequest.Instructions"
                                  [(ngModel)]="CurrentEditClinicalOrderRxHeaderInfoRequest.Instructions" minlength="1" maxlength="100"
                                  #addconcerns_text="ngModel"></textarea>
                        <small class="form-text text-danger"
                               *ngIf="(!addconcerns_text.valid && (addconcerns_text.dirty || addconcerns_text.touched))">(Required)</small>
                      </div>
                    </div>


                  </div>
                </div>
                <div class="row ">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-3 text-align-right margin-top-7px">
                        <label for="diaplayName" class="font-size-12px margin-bottom-0px">Stop Medicine</label>
                      </div>

                      <div class="col-md-4">
                        <input type="checkbox" class="form-control width-14px" id="CurrentStopMedicine.IsStopped"
                               [(ngModel)]="CurrentStopMedicine.IsStopped" name="CurrentStopMedicine.IsStopped">


                      </div>
                    </div>


                  </div>
                </div>
                <div class="row" *ngIf="CurrentStopMedicine.IsStopped">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-3 text-align-right ">
                        <label for="diaplayName">Stop Medicine Reason </label>
                      </div>
                      <div class="col-md-8 padding-right-0px ">
                        <!--<CodeTypeValue CodeType="MARTL"></CodeTypeValue>-->

                        <textarea class="form-control3 size-2 width-inherit" rows="2" placeholder="Stop Medicine Reason"
                                  name="CurrentStopMedicine.StopReason"
                                  [(ngModel)]="CurrentStopMedicine.StopReason" minlength="1" maxlength="100"
                                  #addconcerns_text="ngModel"></textarea>
                        <small class="form-text text-danger"
                               *ngIf="(!addconcerns_text.valid && (addconcerns_text.dirty || addconcerns_text.touched))">(Required)</small>
                      </div>
                    </div>


                  </div>
                </div>




              </div>
            </div>




















          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-left-auto font-size-13px" (click)="activeModal.close('Close click')">Close</button>
            <button type="submit" class="btn actions-btn-prime float-right font-size-13px margin-right-auto">Save</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
